import { render } from "./BasketPopout.vue?vue&type=template&id=0d924ed0&scoped=true"
import script from "./BasketPopout.vue?vue&type=script&lang=js"
export * from "./BasketPopout.vue?vue&type=script&lang=js"

import "./BasketPopout.vue?vue&type=style&index=0&id=0d924ed0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d924ed0"]])

export default __exports__